import React from "react";
import { PeekFormControl, PeekFormLabel, PeekToggleButton, PeekToggleButtonGroup, } from "@piiqtechnologies/ui-components";
import { LayoutSize } from "./SpaceEmbedCodeFormConfig";
const EmbedCodeLayoutSize = ({ field, form, label }) => {
    return (React.createElement(PeekFormControl, null,
        React.createElement(PeekFormLabel, { sx: { mb: 0.5 } }, label),
        React.createElement(PeekToggleButtonGroup, { color: "primary", exclusive: true, 
            //@ts-ignore
            onChange: (_event, value) => form.setFieldValue(field.name, value), orientation: "horizontal", value: field.value }, Object.values(LayoutSize).map((size) => (React.createElement(PeekToggleButton, { key: size, value: size }, size))))));
};
export default EmbedCodeLayoutSize;
